import { gql } from '@apollo/client';

export const UPDATE_BOOK = gql`
  mutation UpdateBook($id: ID!, $input: BookInput) {
    updateBook(id: $id, input: $input) {
      id
    }
  }
`;

export const UPDATE_BOOK_WITH_PRODUCT = gql`
  mutation UpdateBookWithProduct($id: ID!, $input: UpdateBookWithProductInput) {
    updateBookWithProduct(id: $id, input: $input) {
      id
      title
    }
  }
`;
